


const  videoChatState = {
    WaitingMember: 'WaitingMember',
    MemberConected: 'MemberConected', 
    PeerExchange: 'PeerExchange',
    EstablishingConnection: 'EstablishingConnection',
    Conected: 'Conected',
    LostConect: 'LostConect',
    CallEnd: 'CallEnd',
    Error: 'Error'
  };



  export default videoChatState;